import React, {useState, useEffect} from 'react';
import styles from "./result-panel.module.scss";
import { api } from '../../services/api';
// import { calculatePortfolio, calculateImprovement } from '../../utilities/calculator';
import { formatNumberWithDot, formatPortfolioResult } from '../../utilities/utils';
import MapCountries from '../map/MapCountries';
import LoadingSpinner from '../common/loading/LoadingSpinner';


const ResultPanel = ({passports, RCBIs}) => {

    const [radioboxSelected, setRadioboxSelected] = useState('summary');
    const [currencySelected, setCurrencySelected] = useState('usd');
    const [resultsData, setResultsData] = useState(null);

   
    const allCountryCodes = passports.concat(RCBIs);  

    useEffect(() => {
        // function resultData() {
        //     const formdata = new FormData();

        //     for (let i = 0; i<passports.length; i++){
        //         formdata.append("passports[]", passports[i].iso_code)
        //     }

        //     for (let j = 0; j<RCBIs.length; j++){
        //         formdata.append("new_passports[]", RCBIs[j].iso_code);
        //         if(RCBIs[j].type === 'rpi'){
        //             formdata.append(`new_passports_types[${j}]`, "rpi");
        //         }
        //     }
        //     api.post("/calculator", formdata)
        //        .then((response) => {
        //             console.log(response.data);
        //             setResultsData(formatPortfolioResult(response.data));
        //         })
        //         .catch((error) => console.error(error));
    
        // }
        // resultData();
        console.log(RCBIs);
        async function resultData() {
            if(RCBIs.length > 0){
                const formdata = new FormData();

                for (let i = 0; i<passports.length; i++){
                    formdata.append("passports[]", passports[i].iso_code)
                }
    
                for (let j = 0; j<RCBIs.length; j++){
                    formdata.append("new_passports[]", RCBIs[j].iso_code);
                    if(RCBIs[j].type === 'rpi'){
                        formdata.append(`new_passports_types[${j}]`, "rpi");
                    }
                }
           
                const response = await api.post("/calculator", formdata);
                console.log(response.data);
                console.log(formatPortfolioResult(response.data));
                setResultsData(formatPortfolioResult(response.data));
            }
           
           
        }
        resultData();
        
    }, [passports, RCBIs]);

    const handleRadioboxChange = (event) =>{
        setRadioboxSelected(event.target.value);
    }

    const handleCurrencyChange = (event) =>{
        setCurrencySelected(event.target.value);
    }

    // console.log(summaryAll.freeVisaCountries);

    // const totalMinInvestment = ;
    if (!resultsData) return <LoadingSpinner />;

    return(
        <>
            
            <div className={styles.customRadioboxGroup} style={{'width': '100%'}}>
                <label className={styles.customRadiobox}>
                    <input type="radio" value="summary" name="radio" checked={radioboxSelected === 'summary'} onChange={handleRadioboxChange} /> 
                    <span className={styles.labelText}>Summary</span>
                </label>
                <label className={styles.customRadiobox}>
                    <input type="radio" value="globalAccess" name="radio" checked={radioboxSelected === 'globalAccess'} onChange={handleRadioboxChange} /> 
                    <span className={styles.labelText}>Global Access</span>
                </label>
            </div>
       
           
            <div className={styles.summary} style={{display: radioboxSelected === 'summary' ? 'block' : 'none'}}>
                <div className={`row mx-0 align-items-center justify-content-between ${styles.summaryItem}`}>
                    <div className="col px-0"><strong>Total No. of Passports/Investment Migration Residence Permits</strong></div>
                    <div className="col-auto pr-0"><strong>{allCountryCodes.length}</strong></div>
                </div>
                <div className={`row mx-0 align-items-center justify-content-between ${styles.summaryItem}`}>
                    <div className="col px-0"><strong>Ultimate Total No. of Visa-Free Destinations</strong></div>
                    <div className="col-auto pr-0">
                        <strong>
                            {/* {summaryAll.freeVisaCountries.length} */}
                            {resultsData.freeVisaCount}
                        </strong>
                    </div>
                </div>
                <div className={`row mx-0 align-items-center justify-content-between ${styles.summaryItem}`}>
                    <div className="col px-0"><strong>Approximate Total Minimum Investment</strong></div>
                    <div className="col-auto pr-0 d-flex flex-column align-items-end">
                        <div className={styles.currencyBoxGroup}>
                            <label className={styles.customRadiobox}>
                                <input type="radio" value="usd" name="currency" checked={currencySelected === 'usd'} onChange={handleCurrencyChange} /> 
                                <span className={styles.labelText}>USD</span>
                            </label>
                            <label className={styles.customRadiobox}>
                                <input type="radio" value="eur" name="currency" checked={currencySelected === 'eur'} onChange={handleCurrencyChange} /> 
                                <span className={styles.labelText}>EUR</span>
                            </label>
                        </div>
                        <div className={styles.currencyText}>
                        {currencySelected === 'usd' 
                            ? (<span>USD <strong>{formatNumberWithDot(resultsData.minimumInvestmentUSD)}</strong></span>) 
                            : (<span>EUR <strong>{formatNumberWithDot(resultsData.minimumInvestmentEUR)}</strong></span>)
                        } 
                       
                        </div>
                    </div>
                </div>
                <div className={styles.summaryTableWrapper}>
                    <div className={styles.headingText}><strong>My Ultimate Portfolio offers:</strong></div>
                    <table>
                        <thead>
                            <tr>
                                <th>GLOBAL BENEFITS</th>
                                <th>IMPROVEMENT<br />(%)</th>
                                <th>ULTIMATE<br />(Out of 100)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan={3}>
                                    <hr />
                                </td>
                            </tr>
                            <tr>
                                <td>Business Opportunity</td>
                                <td><strong>{Math.round(resultsData.businessOpportunityImprovement) + '%'}</strong></td>
                                <td>{resultsData.businessOpportunity}</td>
                            </tr>
                            <tr>
                                <td>Climate Resilience</td>
                                <td><strong>{Math.round(resultsData.climateResilienceImprovement) + '%'}</strong></td>
                                <td>{resultsData.climateResilience}</td>
                            </tr>
                            <tr>
                                <td>Economic Mobility</td>
                                <td><strong>{Math.round(resultsData.economicMobilityImprovement) + '%'}</strong></td>
                                <td>{resultsData.economicMobility}</td>
                            </tr>
                            <tr>
                                <td>Premium Education</td>
                                <td><strong>{Math.round(resultsData.educationImprovement) + '%'}</strong></td>
                                <td>{resultsData.education}</td>
                            </tr>
                            <tr>
                                <td>Quality of Life</td>
                                <td><strong>{Math.round(resultsData.lifestyleImprovement) + '%'}</strong></td>
                                <td>{resultsData.lifestyle}</td>
                            </tr>
                            <tr>
                                <td>Private Healthcare</td>
                                <td><strong>{Math.round(resultsData.privateHealthcareImprovement) + '%'}</strong></td>
                                <td>{resultsData.privateHealthcare}</td>
                            </tr>
                            <tr>
                                <td>Safety and Security</td>
                                <td><strong>{Math.round(resultsData.safetyAndSecurityImprovement) + '%'}</strong></td>
                                <td>{resultsData.safetyAndSecurity}</td>
                            </tr>
                            <tr>
                                <td colSpan={3} height="30"></td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td><small>My Ultimate Portfolio</small><br /><strong>Total</strong> (out of 700)</td>
                                <td className={styles.total} colSpan={2}>{resultsData.overall}</td>
                            </tr>
                            <tr>
                                <td className="py-0" colSpan={3}><hr /></td>
                            </tr>
                            <tr>
                                <td><small>My Existing Passport Portfolio</small><br /><strong>Total</strong> (out of 700)</td>
                                <td className={styles.total}colSpan={2}>{resultsData.passportOverall}</td>
                            </tr>
                            <tr>
                                <td className="py-0" colSpan={3} height="10"></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
          
            <div className={styles.global} style={{display: radioboxSelected === 'globalAccess' ? 'block' : 'none'}}>
                <div className="mb20"><strong>Your Ultimate Portfolio gives you visa-free access to the following {resultsData.freeVisaCount} destinations:</strong></div>
                {resultsData.freeVisaCount > 0 &&<MapCountries freeVisaCountries={resultsData.freeVisaCountries} />}
            </div>
         
        </>
    );
 
}

export default ResultPanel;